import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD,
  ITEMS_TYPE_SIMILAR
} from "../../../../../constants";
import getCustomerItemsGlobalVars from "./getCustomerItemsGlobalVars";
import getSharedBoardGlobalVars from "./getSharedBoardGlobalVars";

const getItemsTypeGlobalVars = itemsType => {
  const itemsTypeGlobalVarsMap = {
    [ITEMS_TYPE_CUSTOMER_ITEMS]: getCustomerItemsGlobalVars(),
    [ITEMS_TYPE_SHARED_BOARD]: getSharedBoardGlobalVars(),
    [ITEMS_TYPE_SIMILAR]: []
  };

  return itemsTypeGlobalVarsMap[itemsType];
};

export default getItemsTypeGlobalVars;
